var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25C7.37667 1.25 5.25002 3.37665 5.25002 6V7.0702C3.72317 7.35983 2.5035 8.51728 2.12345 10.0101C1.9872 10.5453 2.44774 11 3.00002 11H4.26759C4.6134 11.5978 5.25974 12 6.00002 12C6.74031 12 7.38665 11.5978 7.73246 11H9.00002C9.55231 11 10.0128 10.5453 9.8766 10.0101C9.49655 8.51728 8.27688 7.35983 6.75002 7.0702V6C6.75002 4.20507 8.2051 2.75 10 2.75C11.7949 2.75 13.25 4.20507 13.25 6V21.25H9.00002C8.58581 21.25 8.25002 21.5858 8.25002 22C8.25002 22.4142 8.58581 22.75 9.00002 22.75H19C19.4142 22.75 19.75 22.4142 19.75 22C19.75 21.5858 19.4142 21.25 19 21.25H14.75V6C14.75 3.37665 12.6234 1.25 10 1.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableLamp);
export default __webpack_public_path__ + "static/media/table-lamp.a62a36ba11b776e3b2be1865c827bb97.svg";
export { ForwardRef as ReactComponent };